var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "1200",
            persistent: "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.openDialog,
            callback: function($$v) {
              _vm.openDialog = $$v
            },
            expression: "openDialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "vCardDialogVideo", shaped: "", outlined: "" } },
            [
              _c("div", { attrs: { id: "headerDialogVideo" } }, [
                _c("div", { staticStyle: { "margin-left": "2%" } }, [
                  _c("h2", { staticClass: "textstyle" }, [
                    _vm._v("Ver Coordenadas")
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "auto", "margin-right": "1%" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", dark: "" },
                        on: { click: _vm.closeDialog }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { attrs: { id: "bodyDialogVideo" } }, [
                _c("div", {
                  staticClass: "google-map",
                  attrs: { id: _vm.mapName }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }